<template>
  <li class="flex items-center justify-between space-x-2">
    <div class="flex items-start space-x-2">
      <fa
        v-if="isCrossed"
        :icon="['fas', 'xmark']"
        class="fa-fw text-neutral-500 flex-shrink-0"
      />
      <fa
        v-else
        :icon="['fas', 'check']"
        class="fa-fw text-bubblegum-500 flex-shrink-0"
      />
      <p
        :class="[isCrossed ? 'text-neutral-500' : 'text-neutral-700']"
        class="text-xs"
      >
        {{ label }}
      </p>
    </div>
    <vetster-badge
      v-if="isNew"
      :label="$t('search.new')"
      color="bubblegum"
      size="xs"
      variant="tight"
    />
  </li>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

import VetsterBadge from '@/components/VetsterBadge';

library.add(
  faCheck,
  faXmark,
);

export default {
  name: 'VetsterBenefitListItem',

  components: { VetsterBadge },

  props: {
    isCrossed: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
  },
};
</script>
